const middleware = {}

middleware['auth'] = require('../src/middleware/auth.ts')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['loyalty'] = require('../src/middleware/loyalty.ts')
middleware['loyalty'] = middleware['loyalty'].default || middleware['loyalty']

middleware['maintenance'] = require('../src/middleware/maintenance.ts')
middleware['maintenance'] = middleware['maintenance'].default || middleware['maintenance']

export default middleware
